import { render, staticRenderFns } from "./LayoutWithPhone.vue?vue&type=template&id=8b89eb76"
import script from "./LayoutWithPhone.vue?vue&type=script&lang=js"
export * from "./LayoutWithPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports